import { Stack, Typography, useTheme } from "@mui/material";
import { HStack } from "Components/_Shared/Core/Stack";
import { InfoTooltip } from "Components/_Shared/InfoTooltip";
import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import type { FC } from "react";

type Props = {
  title: string;
  isPlus?: boolean;
  isTitleSemiBold?: boolean;
  isHighlighted?: boolean;
  isFinancialProduct?: boolean;
  amount: string;
  tooltip?: string;
};

export const RecapRow: FC<Props> = ({ title, isPlus, isTitleSemiBold, isHighlighted, isFinancialProduct, amount, tooltip }) => {
  const theme = useTheme();
  const { t } = useResource();

  const getColor = () => {
    if (isHighlighted) {
      if (isFinancialProduct) {
        return theme.colors.brandPrimary;
      }

      if (Number.parseInt(amount) >= 0) {
        return theme.palette.success.main;
      }

      return theme.palette.error.main;
    }

    return "text.primary";
  };

  return (
    <HStack spacing={Spacing.L} justifyContent="space-between">
      <HStack spacing={Spacing.S} alignItems="center">
        <Typography variant="body2" fontWeight={isTitleSemiBold ? 500 : 400}>
          {title}
        </Typography>

        {!!tooltip && <InfoTooltip title={tooltip} />}
      </HStack>

      <Stack direction="column" alignItems="flex-end">
        <HStack spacing={Spacing.S}>
          <Typography variant="body2" fontWeight={500} color={getColor()}>
            {isPlus ? `+ ${amount}` : amount}
          </Typography>

          <Typography variant="body2" color="text.secondary" fontWeight={400}>
            {t(Resources.Common.CZKSuffix)}
          </Typography>
        </HStack>

        <Typography variant="caption" color="text.secondary" fontWeight={400}>
          /{t(Resources.Common.Month)}
        </Typography>
      </Stack>
    </HStack>
  );
};
